var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5022 13.3683V5.81556C7.5022 3.09642 9.31795 3.1129 10.2062 2.92524C14.6818 0.612981 16.2255 3.57773 16.3499 5.34913V13.3683C16.3499 15.5338 14.9911 17.8339 12.0781 17.8339C9.3419 17.8339 7.5022 15.4352 7.5022 13.3683Z",
    stroke: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71509 12.1982C9.77348 11.801 12.5805 11.2449 15.3413 12.1982",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45506 22.9221C3.34693 21.5383 3.85737 18.7836 6.76415 18.8352C9.67092 18.8868 9.7518 18.2055 9.42889 17.8584",
    stroke: "#707070",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5449 22.9221C20.6531 21.5383 20.1426 18.7836 17.2359 18.8352C14.3291 18.8868 14.2482 18.2055 14.5711 17.8584",
    stroke: "#707070",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9231 6.47808C9.23837 5.16291 12.1862 3.23222 13.4553 6.03081C13.7482 7.13758 13.5773 7.95664 13.4553 8.22782C14.3638 8.14606 16.2051 7.68164 16.3027 6.47808",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.89a0b54d4f9e88f4705949c76cee0fe6.svg";
export { ForwardRef as ReactComponent };